import * as types from './mutation-types';
import { defaultState } from './state';
import * as _ from 'lodash';

const resetState_ = state => {
	// Object.assign(state, defaultState);
	Object.assign(state, _.cloneDeep(defaultState));
};
const resetYnState_ = state => {
	state.useYnList = [];
	state.gridUseYnList = [];
	state.systems = [];
	state.gridScrType = [];
	// Object.assign(state, defaultState);
};
export default {
	resetYnState_,
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.TREE_LIST]: (state, payload) => {
		// 2022-03-07
		const { menus } = payload;

		const makeTree = menuItemList => {
			if (!Array.isArray(menuItemList) || (Array.isArray(menuItemList) && menuItemList.length === 0)) return [];
			else {
				return menuItemList.map(menuItem => {
					const { scrName, menuItemList } = menuItem;
					return { ...menuItem, label: scrName, children: makeTree(menuItemList) };
				});
			}
		};

		const children = menus.map(menu => {
			const { scrName, menuItemList } = menu;
			return { ...menu, label: scrName, children: makeTree(menuItemList) };
		});

		state.menuTree = [
			{
				label: 'Root',
				children
			}
		];
	},
	[types.MENU_LIST]: (state, payload) => {
		state.menus = payload;
		if (state.menus != null) {
			state.menus.forEach(row => {
				if (row.scrName == null) row.scrName = '[화면명 선택]';

				Object.keys(row).forEach(item => {
					if (item == 'regDt') {
						let tmpDate = new Date(row[item]);
						row[item] =
							tmpDate.getFullYear() +
							'-' +
							('0' + (tmpDate.getMonth() + 1)).substr(0, 2) +
							'-' +
							('0' + tmpDate.getDate()).substr(0, 2) +
							' ' +
							('0' + tmpDate.getHours()).substr(0, 2) +
							':' +
							('0' + tmpDate.getMinutes()).substr(0, 2) +
							':' +
							('0' + tmpDate.getSeconds()).substr(0, 2);
					}
				});
			});
		}
	},
	[types.SELECTED_MENU]: (state, payload) => {
		state.selectedMenu = payload;
	}
};
